import React from 'react';
import { ProgressBar } from 'react-bootstrap';

interface PropsObject {
    title: string,
    hoursTracked: string,
    percentageValue: string,
    isActive: boolean
}

const TrackedTime: React.FC<PropsObject> = (props) => {
    const { title, hoursTracked, percentageValue, isActive } = props

    return (
        <div className='ps-bar-cont'>
            <h4>{title}</h4>
            <p>{hoursTracked}</p>
            <div className='activity-percent'>
                <div className={`pcg-box ${isActive ? '' : 'danger'}`}>
                    <p>{percentageValue}%</p>
                </div>
                <ProgressBar className='cus-progress' now={Number(percentageValue)} variant={`${isActive ? 'active' : 'in-active'}-color`} />
            </div>
        </div>
    );
};

export default TrackedTime;